import {ReceiptPositionDto} from "./receipt-position.dto";
import {DocumentContactDto} from "./document-contact.dto";
import {DocumentPaymentDto} from "./document-payment.dto";
import {isDefined, isFalse} from "../../libs/utils/epic.utils";
import {AccAmountPipe} from "../../libs/pipes/amount.pipe";
import {ReceiptType} from "../../libs/enum/receipt-type.enum";
import {BookingCategory} from "../../libs/enum/booking-category.enum";

export class ReceiptDto implements AccAmountPipe {

  public readonly id!: string;
  public type!: ReceiptType;
  public readonly number!: string; // Acc Receipt-Number (generated)
  public receiptNumber: string | undefined; // Contact Receipt-Number (receive / entered)
  public receiptDate: Date | undefined;
  public totalNetAmount: number | undefined;
  public totalGrossAmount: number | undefined;
  public readonly totalVatAmount: number | undefined;
  public currencyCode!: string;
  public mediaId: string | undefined;
  public destinationCity: string | undefined;
  public destinationZipCode: string | undefined;
  // Distance in kilometers
  public destinationDistance: number | undefined;
  public destinationContactId: string | undefined;
  public techType: string | undefined; // ReceiptMediaType
  public techMediaId: string | undefined;
  public readonly reviewed!: boolean;
  public readonly approved!: boolean;
  public readonly commentCount!: number;
  public readonly booked!: boolean;
  // If 'bookingCategory' is changed, 'bookingCategoryId' must be set to 'undefined'
  public bookingCategoryId: string | undefined;
  public bookingCategory: BookingCategory | undefined;
  public contactId: string | undefined;
  public contact: DocumentContactDto | undefined;
  public /* readonly */ positions: ReceiptPositionDto[] = [];
  public /* readonly */ payment: DocumentPaymentDto | undefined;

  constructor(init?: Partial<ReceiptDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.receiptDate)) {
      this.receiptDate = new Date(init.receiptDate);
    }
    if (isDefined(init?.contact)) {
      this.contact = new DocumentContactDto(init.contact);
    }
    if (isDefined(init?.positions)) {
      this.positions = init.positions.map((i) => new ReceiptPositionDto(i))
        .sort((i1, i2) => i1.pos < i2.pos ? -1 : i1.pos > i2.pos ? 1 : 0);
    } else {
      this.positions = [];
    }
    if (isDefined(init?.payment)) {
      this.payment = new DocumentPaymentDto(init.payment);
    }
  }

  // AccAmountPipe
  public getCurrencyCode(): string {
    return this.currencyCode;
  }

  // AccAmountPipe
  public getPreferCurrencyCode(): string | undefined {
    return undefined;
  }

  public isEditable(): boolean {
    return isFalse(this.reviewed) && isFalse(this.booked);
  }

  public hasPositions(): boolean {
    return isDefined(this.positions) && this.positions.length > 0;
  }

  public hasPaymentBalance(): boolean {
    return isDefined(this.payment) && isFalse(this.payment.completed);
  }

  public getPaymentBalance(): number | undefined {
    if (this.hasPaymentBalance()) {
      return this.payment?.balance;
    }
    return undefined;
  }

  // AccAmountPipe // used: CurrencyPipe / PaymentEnterComponent
  public getFractionalDigits(): number {
    return 2;
  }

  public hasPaymentEntries(): boolean {
    return isDefined(this.payment) && this.payment.entries.length > 0;
  }

  public hasOldParts(): boolean {
    return this.hasPositions()
      ? this.positions.some((p) => p.isOldPart())
      : false;
  }

  public sumOldParts(): number {
    if (this.hasOldParts()) {
      return this.positions.filter((p) => p.isOldPart())
        .reduce((sum, p) => sum + p.oldPartTotalVatAmount!, 0);
    }
    return 0;
  }
}
